export default __webpack_public_path__ + "static/1-ed82dccde85ef97c1b5feb6c8d2c17e8.gif";